import { IInvoice, InvoiceStatus } from "../../../models/invoice";

export function getReadyForBillingInvoices(invoices: IInvoice[]) {
    return invoices.filter(invoice => invoice.invoiceStatus === InvoiceStatus.READY_FOR_BILLING);
}

export function getReadyForBillingInvoiceIds(invoices: IInvoice[]) {
    return getReadyForBillingInvoices(invoices).map(({ id }) => id);
}
